import { useHistory } from 'react-router';

export const useNavigate = () => {
  const history = useHistory();
  return (path: string) => {
    history.push(path);
  };
};
